/* eslint-disable react/prefer-es6-class, react/sort-comp, react/jsx-indent */
import React from 'react';
import ProgressBar from 'es6/components/common/progress-bar';
import Localization from 'es6/services/localization';
import { Stats, Stat, StatData, StatLabel } from 'es6/components/apps/stats';
import { TranscodedImageSizes, TranscodedImage } from 'es6/components/common/transcoded-image';

/**
 * Displays the basic information about a course. If an aggregateMemory is provided,
 * the teaser will also show progress and display a ribbon over the image icon.
 */
export default React.createClass({
  displayName: 'CourseTeaser',

  /**
   * enableRibbon and enableStudyStats depend on aggregateMemory being set.
   *
   * enableRibbon: Wil add a "new" ribbon if the course is new for the user
   * enableStudyStats: Will show stat pills instead of typical course details.
   */
  propTypes: {
    aggregateMemory: React.PropTypes.object,
    enableRibbon: React.PropTypes.bool,
    enableStudyStats: React.PropTypes.bool,
    goal: React.PropTypes.object.isRequired,
  },

  getDefaultProps() {
    return {
      aggregateMemory: null,
      enableRibbon: false,
      enableStudyStats: false,
    };
  },

  /**
   * Helper method to determine if the user has started a course.
   *
   * @returns {Boolean}
   */
  _hasStartedCourse() {
    return this.props.aggregateMemory && this.props.aggregateMemory.startedAt;
  },

  render() {
    let progressBar = null;

    if (this.props.aggregateMemory && this.props.aggregateMemory.items) {
      progressBar = (<ProgressBar progress={this.props.aggregateMemory.items.progress} showProgressTag />);
    }

    return (
      <div className="course-teaser">
        {this._renderImage()}

        <div className="course-details">
          <div className="course-title-container">
            <h1 className="course-title">{this.props.goal.title}</h1>
            {progressBar}
          </div>

          {this.props.enableStudyStats && this._hasStartedCourse() ?
            this._renderStudyStats() : this._renderDetails()}
        </div>
      </div>
    );
  },

  /**
   * Renders course details.
   */
  _renderDetails() {
    return [
      (
      <div key="level" className="course-detail course-detail-inline course-detail-level">
          <span className="primary">{Localization.t('js_iknow.level')} </span>
          <span className="secondary">{this.props.goal.getDifficultyLevel()}</span>
        </div>
      ),
      (
      <div key="item-count" className="course-detail course-detail-inline course-detail-items">
          <span className="primary">{Localization.t('items-label')} </span>
          <span className="secondary">{this.props.goal.itemsCount}</span>
        </div>
      ),
      (
      <div key="sentence-count" className="course-detail course-detail-inline course-detail-sentences">
          <span className="primary">{Localization.t('sentences-label')} </span>
          <span className="secondary">{this.props.goal.sentencesCount}</span>
        </div>
      ),
    ];
  },

  /**
   * Renders image for the course page, with or without a ribbon marking it
   * as new.
   */
  _renderImage() {
    let ribbon = null;

    if (!this.props.goal.icon) {
      return null;
    }

    // If there is an aggregateMemory, but unstarted. Add the  as new.
    if (this.props.enableRibbon && !this._hasStartedCourse()) {
      ribbon = (
        <div className="ribbon ribbon-corner ribbon-corner-large-image ribbon-orange">
          <div className="ribbon-message">{Localization.t('ribbon-message.new')}</div>
        </div>
      );
    }

    return (
      <div className="course-image">
        {ribbon}
        <TranscodedImage src={this.props.goal.icon} size={TranscodedImageSizes.LARGE} />
      </div>
    );
  },

  /**
   * Renders study statistics for a course.
   */
  _renderStudyStats() {
    const aggregate = this.props.aggregateMemory;
    const goal = this.props.goal;

    return (
      <Stats>
        <Stat type="started">
          <StatData>
            {aggregate.items.studiedItemsCount}
            <span className="slash">/</span>
            <span className="total">{goal.getTotalItemsCount(aggregate)}</span>
          </StatData>
          <StatLabel>{Localization.t('items-started')}</StatLabel>
        </Stat>

        <Stat type="strong">
          <StatData>{aggregate.items.getItemsAtCheckpoint1()}</StatData>
          <StatLabel>{Localization.t('items-zone-1')}</StatLabel>
        </Stat>

        <Stat type="mastered">
          <StatData>{aggregate.items.itemsAtCheckpoint2}</StatData>
          <StatLabel>{Localization.t('items-mastered')}</StatLabel>
        </Stat>
      </Stats>
    );
  },
});
